import { LoaderFunction } from "react-router-dom";
import { pricesApi } from "src/api/services/pricesApi";
import { store } from "src/api/store";

export const priceLoader: LoaderFunction = ({ params }) => {
  if (params.priceId != null) {
    return store
      .dispatch(pricesApi.endpoints.getPrice.initiate(Number(params.priceId)))
      .unwrap();
  }
};
